module.exports = __webpack_public_path__ + "/images/cover-mujeres-consultando-ordenador-2x.0e60624.jpg";